// extracted by css-extract-rspack-plugin
export default {"loader":"Qvry2","loader-spin":"o5YqW","loaderSpin":"o5YqW"};